import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "contexts/AuthContext";

interface ProtectedRouteProps {
  allowedRoles: number[];
  fallbackPath: string;
}

export default function ProtectedRoute({ allowedRoles, fallbackPath }: ProtectedRouteProps) {
  const { user, loading, profile } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          color: "#fff",
          fontSize: "1.2rem",
        }}
      >
        Đang tải...
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (profile === null) {
    return <Navigate to="/pending" replace />;
  }

  if (profile.role < 0) {
    return <Navigate to="/pending" replace />;
  }

  if (!allowedRoles.includes(profile.role)) {
    return <Navigate to={fallbackPath} replace />;
  }

  return <Outlet />;
}